class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    FacetFiltersForm.mff_setUpFilters();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }



  // 2024
  // show or hide elements on the page based on filtered list
  static mff_runFilters() {
    var _this = FacetFiltersForm; // static object

    $('#mff-no-results-found').hide();

    const product_data_g = _this.mff_instantiateSearchables();

    // get filter elements of page and build a filtered list and hide accordingly
    var filters = {
      'attributes': [],
      'size_categories': [],
      'categories': [],
      'cals': [],
      'pro': [],
      'search': document.querySelector('#mff-product-search').value.toLowerCase()
    };

    var search_unchecked = true;
    if (filters.search != '') search_unchecked = false;

    // could be multiple sizes
    var size_cat_unchecked = true;
    document.querySelectorAll('.size-category-filter-box').forEach((el) => {
      if (el.checked) {
        filters.size_categories.push(el.value);
        size_cat_unchecked = false;
      }
    })


    // lunch / dinner / breakfast - could be multiple - so have to array break down
    var cat_unchecked = true;
    document.querySelectorAll('.category-filter-box').forEach((el) => {
      if (el.checked) {
        filters.categories.push(el.value);
        cat_unchecked = false;
      }
    })

    // actually scans all meta attributes such as best seller, new prods, etc.
    var attribute_unchecked = true;
    document.querySelectorAll('.attribute-filter-box').forEach((el) => {
      if (el.checked) {
        filters.attributes.push(el.value);
        attribute_unchecked = false;
      }
    });


    var cals_unchecked = true;
    document.querySelectorAll('.cal-filter-box').forEach((el) => {
      if (el.checked) {
        filters.cals.push(el.value);
        cals_unchecked = false;
      }
    });

    var pro_unchecked = true;
    document.querySelectorAll('.pro-filter-box').forEach((el) => {
      if (el.checked) {
        filters.pro.push(el.value);
        pro_unchecked = false;
      }
    });

    // iterate all products and apply filters
    var show_counter = 0;
    product_data_g.forEach(function (a) {
      var size_cat_should_show = false;
      var cat_should_show = false;
      var attribute_should_show = false;
      var search_should_show = false;
      var cals_should_show = false;
      var pro_should_show = false;

      // protein
      if (!pro_unchecked) {
        filters.pro.forEach(function (b) {
          var tmp = b.split('-');

          if (a.custom_fields) {
            a.custom_fields.forEach(function (c) {
              if (c.name == 'Protein') {
                if (c.value >= tmp[0] && c.value <= tmp[1]) {
                  pro_should_show = true;
                }
              }
            });
          } else pro_should_show = true;
        });
      } else pro_should_show = true;

      // cals
      if (!cals_unchecked) {
        filters.cals.forEach(function (b) {
          var tmp = b.split('-');

          if (a.custom_fields) {
            a.custom_fields.forEach(function (c) {
              if (c.name == 'Calories') {
                if (c.value >= tmp[0] && c.value <= tmp[1]) {
                  cals_should_show = true;
                }
              }
            });
          } else cals_should_show = true;
        });
      } else cals_should_show = true;

      // search
      if (!search_unchecked) {
        if (a.name.toLowerCase().indexOf(filters.search) !== -1
          || a.summary.toLowerCase().indexOf(filters.search) !== -1) {
          search_should_show = true;
        }
      } else {
        search_should_show = true;
      }

      // size_cats
      if (!size_cat_unchecked) {
        filters.size_categories.forEach(function (b) {
          if (a.size) {
            const meal_sizes = JSON.parse(a.size);

            meal_sizes.forEach((c) => {
              if (b.toLowerCase() == c.toLowerCase()) {
                size_cat_should_show = true;
              }
            });
          }
        });
      } else size_cat_should_show = true;

      // cats
      if (!cat_unchecked) {
        filters.categories.forEach(function (b) {

          if (a.categories) {
            const categories = JSON.parse(a.categories);

            categories.forEach((c) => {
              if (b.toLowerCase() == c.toLowerCase()) {
                cat_should_show = true;
              }
            });
          }
        });
      } else cat_should_show = true;

      // allergens & attributes - checkbox only / non value / radio
      attribute_should_show = true;
      if (!attribute_unchecked) {
        filters.attributes.forEach(function (b) {
          if (a.custom_fields && attribute_should_show) {
            a.custom_fields.forEach(function (c) {
              if (c.name == b) {

                if (!(c.value == 'true')) {
                  attribute_should_show = false;
                }
              }
            });
          }
        });
      }

      var obj = document.querySelector(`.product-card-wrapper [data-id='${a.id}']`);
      if (size_cat_should_show && cat_should_show && attribute_should_show && search_should_show && cals_should_show && pro_should_show) {
        obj.parentElement.parentElement.style.display = "list-item";
        show_counter++;
      } else {
        obj.parentElement.parentElement.style.display = "none";
      }
    });

    // few results
    if (show_counter <= 3) $('#mff-no-results-found').show();
  }


  // 2024 to replace convert cart search and filtering
  static mff_setUpFilters() {
    var _this = FacetFiltersForm; // static object

    // todo this gets called for all facet filters, but should only function on the search one

    if (_this.initialized) {
      return;
    }

    _this.mff_instantiateSearchables();

    // hook up the search buttons

    // event listeners
    var el = document.querySelector('#mff-product-search');
    var timer = null;
    el.addEventListener("keyup", (event) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        _this.mff_runFilters();
      }, 100);
    });


    el = document.querySelectorAll('.mff-filter-box').forEach((el) => {
      el.addEventListener("change", (event) => {
        _this.mff_runFilters();
      });
    });

    el = document.querySelector('.mobile-facets__clear');
    el.addEventListener('click', (event) => {
      _this.mff_clearSearch(_this);
    });


    // old code uses jquery which apparently is in this theme

    // bring back icon click and focus
    // $('.sidebar-search .icon-search').on('click', function () {
    //   $('#product-search').trigger('select');
    // });

    // $('#mff-product-search').trigger('focus');



    $('#clear-search-filter').on('click', function () {
      _this.mff_clearSearch(_this);
    });


    // test on android filter goes away on android

    // $('#product-search-form').on('submit', function (e) {
    //   // hack to hide android keyboard when user presses enter
    //   e.preventDefault();
    //   $('#category-filter-flyout-button').trigger('focus');
    // });



    // check param line for mff searches
    // pass in form values to auto checkbox these filters on load
    // use drawer = anyting to open the drawer on load. sample:
    // http://127.0.0.1:9292/collections/all-meals?filters=Best%20Seller;Regular&drawer=1
    // https://www.myfitfoods.com/collections/all-meals?filters=Best%20Seller;Regular&drawer=1
    setTimeout(() => {
      let params = new URL(document.location.href).searchParams;
      let filters = params.get("filters");
      let drawer = params.get("drawer");

      if(filters) {
        filters = filters.split(';');
        filters.forEach((name) => {
          // check a box matching filter(s)
          name = name.trim();
          let el = document.forms.namedItem('FacetFiltersFormMobile').querySelector(`input[value='${name}']`);
          if(el) el.click();
        });
      }
      
      if(drawer) {
        let drawerForm = document.querySelector('#main-collection-filters menu-drawer details');
        drawerForm.classList.add('menu-opening');
        drawerForm.open = true;
      }
    }, 500);

    _this.initialized = true;
  }


  static mff_clearSearch(form) {
    $('#mff-product-search').val('');
    $('.mff-filter-box').prop("checked", false);
    form.mff_runFilters();
  }


  static mff_instantiateSearchables() {
    if (!FacetFiltersForm.product_data) {

      // build object
      FacetFiltersForm.product_data = [];

      document.querySelectorAll('div.product-card-wrapper>div').forEach((prod) => {

        if (prod.dataset.id) {

          var tmp = {
            id: prod.dataset.id,
            name: prod.dataset.name,
            price: prod.dataset.price,
            summary: prod.dataset.description,
            size: prod.dataset.mealSize,
            categories: prod.dataset.mealTypes,
            custom_fields: [
              {
                name: 'Calories',
                value: prod.dataset.calories
              },
              {
                name: 'Gluten Free',
                value: prod.dataset.glutenFree,
              },
              {
                name: 'Low GI',
                value: prod.dataset.lowGi,
              },
              {
                name: 'Reduced Sodium',
                value: prod.dataset.reducedSodium,
              },
              {
                name: 'Protein',
                value: prod.dataset.protein,
              },
              {
                name: 'Total Fat',
                value: prod.dataset.fat,
              },
              {
                name: 'Total Carbohydrates',
                value: prod.dataset.carbs,
              },
              {
                name: 'Allergens',
                value: prod.dataset.allergens,
              },
              {
                name: 'New',
                value: prod.dataset.new,
              },
              {
                name: 'Low Carb',
                value: prod.dataset.lowCarb,
              },
              {
                name: 'Dairy Free',
                value: prod.dataset.dairyFree,
              },
              {
                name: 'Best Seller',
                value: prod.dataset.bestSeller,
              },
              {
                name: 'Meal Types',
                value: prod.dataset.mealTypes,
              }

            ]
          };

          FacetFiltersForm.product_data.push(tmp);
        }
      });
    }

    return FacetFiltersForm.product_data;
  }




  static renderPage(searchParams, event, updateURLHash = true) {

    /* replace shopify ajax with inline js filtering */
    /* shopify is too limited */

    const product_data = FacetFiltersForm.mff_instantiateSearchables();


    // temp disabled og search todo

    // FacetFiltersForm.searchParamsPrev = searchParams;
    // const sections = FacetFiltersForm.getSections();
    // const countContainer = document.getElementById('ProductCount');
    // const countContainerDesktop = document.getElementById('ProductCountDesktop');
    // const loadingSpinners = document.querySelectorAll(
    //   '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    // );
    // loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    // document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    // if (countContainer) {
    //   countContainer.classList.add('loading');
    // }
    // if (countContainerDesktop) {
    //   countContainerDesktop.classList.add('loading');
    // }

    // sections.forEach((section) => {
    //   const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
    //   const filterDataUrl = (element) => element.url === url;

    //   FacetFiltersForm.filterData.some(filterDataUrl)
    //     ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
    //     : FacetFiltersForm.renderSectionFromFetch(url, event);
    // });

    // if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
